import React, { useState } from 'react';
import clsx from 'clsx';
import NavTop from '@icoach/navigation/NavTop';
import NavContent from '@icoach/navigation/NavContent';
import NavBottom from '@icoach/navigation/NavBottom';
import { Icons, ClickAwayListener, Button, Paper } from "@curves/ui-base";
import useEnvName from '@util/hook/useEnvName';

const NavigationPage = () => {
    const envName = useEnvName();
    const station = envName && `station-${envName}`;
    const [open, setOpen] = useState(false);

    const handleToggleMenu = () => {
        setOpen((prev) => !prev);
    };
    const handleCloseMenu = () => {
        setOpen(false);
    };

    return (
        <div className={clsx('nav', { open })}>
            <ClickAwayListener onClickAway={handleCloseMenu}>
                <Paper elevation="4" className={clsx(`nav-container`, station)}>
                    <Button variant="contained" className={clsx('main-menu-btn', station)} onClick={handleToggleMenu}>
                        <Icons.Bars htmlColor={'#fff'} />
                    </Button>
                    <NavTop onCloseMenu={handleCloseMenu} />
                    <NavContent onCloseMenu={handleCloseMenu} />
                    <NavBottom />
                </Paper>
            </ClickAwayListener>
        </div>
    );
};

export default NavigationPage;
